import hyphenize from 'hyphenize'

export default
  hyphenize: hyphenize
